import { Box, Button, Checkbox, FormControlLabel, Popover, Popper, Radio, RadioGroup, Typography, useTheme } from '@mui/material'
import React, { useMemo, useState } from 'react'
import Latex from 'react-latex-next'
import { latexDelimiters } from '../../../utils/utilities'
import { observer } from 'mobx-react'
import { useQuizAndQuestionbankStore } from '../../../store/quiz.store'

const HybridClassVideoQuizPopover = observer( ( { open, anchorEl, eventPopupDetails, handleClose } ) => {

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState( 0 )
    const QuizStore = useQuizAndQuestionbankStore()

    const question = useMemo( () => {
        if ( eventPopupDetails.questions && eventPopupDetails.questions.length > 0 ) {
            return eventPopupDetails.questions[currentQuestionIndex]
        }
    }, [eventPopupDetails, currentQuestionIndex] )

    const [value, setValue] = useState( {} )

    const validForSave = useMemo( () => {
        let allAnswered = true
        for ( const q of eventPopupDetails.questions ) {
            if ( value[q.id] === undefined || value[q.id] === null || ( Array.isArray( value[q.id] ) && value[q.id].length === 0 ) ) {
                allAnswered = false
                break
            }
        }
        return allAnswered
    }, [value, eventPopupDetails] )

    const { palette, layout } = useTheme()

    const changeMultipleAnswersValues = ( val, index ) => {
        try {
            let newValues = { ...value }
            newValues[question.id][index] = val
            setValue( newValues )
            QuizStore.setAttemptingAnswers( { ...QuizStore.getAttemptingAnswers, [question.id]: newValues } )
        } catch ( err ) { }
    }

    const changeValue = ( val ) => {
        setValue( prev => ( { ...prev, [question.id]: val } ) )
        QuizStore.setAttemptingAnswers( { ...QuizStore.getAttemptingAnswers, [question.id]: val } )
    }

    const save = () => {
        handleClose( eventPopupDetails.event )
    }

    const resetCurrentQuestion = () => {
        QuizStore.setAttemptingAnswers( { ...QuizStore.getAttemptingAnswers, [question?.id]: undefined } )
    }

    const reset = () => {
        resetCurrentQuestion()
        setValue( prev => ( { ...prev, [question?.id]: question?.selection_type === 'single' ? null : [] } ) )
    }

    const moveInQuestionListBy = ( offset = 1 ) => {
        if ( currentQuestionIndex + offset <= eventPopupDetails.questions.length - 1 && currentQuestionIndex + offset >= 0 ) {
            setCurrentQuestionIndex( currentQuestionIndex + offset )
        }
    }


    return (
        <Popover
            disablePortal
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            anchorEl={eventPopupDetails.anchorEl}
            open={open}
            slotProps={{
                root: {
                    sx: {
                        marginTop: "-10px"
                    }
                },
                paper: {
                    sx: {
                        overflow: "visible",
                        maxWidth: "600px",
                        width: "90%"
                    }
                }
            }}
        >
            <Popper open={true} sx={{ zIndex: 200000, }} placement='top' anchorEl={anchorEl}>
                <Box sx={{
                    marginTop: "-30px",
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: '50%',
                        bottom: "12px",
                        transform: 'translate(-50%, 100%)',
                        width: 0,
                        height: 0,
                        borderLeft: '10px solid transparent',
                        borderRight: '10px solid transparent',
                        borderTop: `10px solid ${palette.background.paper}`,
                        marginTop: "-20px"
                    }
                }}>

                </Box>
            </Popper>

            <Box padding="20px" width="100%">
                <Box >

                    <Box className='questionbank-wysiwyg-container' fontWeight="700" marginTop="-5px" fontSize="16px">
                        <Latex delimiters={latexDelimiters}>{question.question_text}</Latex>
                    </Box>

                    <Typography variant='subtitle2' color="textSecondary">
                        <em>{question.question_type}</em> <em>{question.selection_type}</em>
                    </Typography>

                    {question.selection_type === "single" && <Box marginTop="20px" paddingLeft="10px">
                        <RadioGroup
                            sx={{ display: "flex", flexDirection: "column", gap: "10px" }}
                            value={value[question.id] || ""}
                            onChange={e => changeValue( e.target.value )}
                        >
                            {question.options.map( ( option, optionIndex ) => {
                                return (
                                    <FormControlLabel
                                        sx={{
                                            padding: { xs: "2px 10px", md: "2px 200px 2px 10px" },
                                            background: value[question.id] && +value[question.id] === optionIndex ? palette.success.main : "none",
                                            border: `1px solid ${value[question.id] && +value[question.id] === optionIndex ? palette.success.main : "#d3d3d3"}`,
                                            borderRadius: "5px",
                                        }}
                                        key={optionIndex}
                                        value={optionIndex}
                                        control={
                                            <Radio
                                                sx={{
                                                    '&.Mui-checked': {
                                                        color: "white",
                                                    }
                                                }}
                                                size='medium'
                                                color='success' />
                                        }
                                        label={
                                            <Box color={value[question.id] && +value[question.id] === optionIndex ? "white" : palette.defaultColor} paddingLeft="20px" fontSize="14px">
                                                <Latex delimiters={latexDelimiters}>{option.option_text}</Latex>
                                            </Box>
                                        }
                                    />
                                )
                            } )}
                        </RadioGroup>
                    </Box>}
                    {question.selection_type === "multiple" && <Box
                        marginTop="20px"
                        paddingLeft="10px"
                        display="flex"
                        width="max-content"
                        flexDirection="column"
                        gap="10px"
                        value={value[question.id] || ""}
                    >
                        {question?.options && question.options.map( ( option, optionIndex ) => {
                            return (
                                <FormControlLabel
                                    sx={{
                                        padding: { xs: "5px 10px", md: "5px 200px 5px 10px" },
                                        background: value[question.id] && value[question.id][optionIndex] ? palette.success.main : "none",
                                        border: `1px solid ${value[question.id] && value[question.id][optionIndex] ? palette.success.main : "#d3d3d3"}`,
                                        borderRadius: "5px",
                                    }}
                                    key={optionIndex}
                                    onChange={
                                        ( e ) => changeMultipleAnswersValues( e.target.checked, optionIndex )
                                    }
                                    checked={value[question.id][optionIndex] || false}
                                    control={<Checkbox sx={{
                                        '&.Mui-checked': {
                                            color: "white",
                                        }
                                    }} />}
                                    label={
                                        <Box color={value[question.id] && value[question.id][optionIndex] ? "white" : palette.defaultColor} paddingLeft="20px" fontSize="14px" dangerouslySetInnerHTML={{ __html: option.option_text }}></Box>
                                    }
                                />
                            )
                        } )}
                    </Box>}
                    <Box display="flex" marginTop="40px" gap="10px" justifyContent="flex-end" alignItems="center">
                        {value[question.id] && <Button onClick={reset} sx={{ paddingX: "40px", borderRadius: "20px", color: "GrayText", ":hover": { color: "secondary.main" } }} color='secondary'  >Reset</Button>}
                        {currentQuestionIndex !== 0 && <Button onClick={() => moveInQuestionListBy( -1 )} variant='outlined' sx={{ borderRadius: "20px" }} disableElevation color="secondary" >Previous</Button>}
                        {currentQuestionIndex < eventPopupDetails.questions.length - 1 && <Button onClick={() => moveInQuestionListBy()} sx={{ paddingX: "40px", borderRadius: "20px" }} variant='contained' disableElevation color="secondary" >Next</Button>}
                        {currentQuestionIndex === eventPopupDetails.questions.length - 1 && <Button disabled={!validForSave} onClick={save} sx={{ paddingX: "40px", borderRadius: "20px" }} variant='contained' disableElevation color="secondary" >Save</Button>}
                    </Box>
                </Box>
            </Box>
        </Popover>
    )
} )

export default HybridClassVideoQuizPopover
